/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation(
    $ageRating: String!
    $cast: [JSON]!
    $subtitleDetails: [JSON]
    $content: [JSON]!
    $contentLink: String!
    $contentLanguage: String!
    $contentTitle: String!
    $contentType: String!
    $dop: String
    $producer: String!
    $genre: [String]!
    $music: String!
  ) {
    ContentAddMoreByAdminUpdated(
      ageRating: $ageRating
      cast: $cast
      subtitleDetails: $subtitleDetails
      content: $content
      contentLink: $contentLink
      contentLanguage: $contentLanguage
      contentTitle: $contentTitle
      contentType: $contentType
      dop: $dop
      producer: $producer
      genre: $genre
      music: $music
    ) {
      status
      message
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
